/**
 * Invoices/View Controller
 *
 * Displays information about a particular invoice
 */

// the constructor for this object
function InvoicesViewController() { }

// the object
InvoicesViewController.prototype = {
    constructor: InvoicesViewController,
    
    // the account id of the invoice
    accountId: false,
    
    // the cycle log id of the invoice
    cycleLogId: false,
    
    // initialize the controller
    init: function() 
    {
        // the user must be logged in to access this page
        PortalMain.authRedirect();
        
        // register the route variables used by this controller
        this._registerRouteVariables();
        
        // register the charts
        this._registerCharts();
        
        PortalHelper.debugMessage('Invoices View Initialized');
    },
    
    // run the controller
    run: function()
    {
        // get and populate the invoice
        this._getInvoice();
        
        // get the invoice product breakdown and populate the chart
        this._getInvoiceProductBreakdown();
        
        // register the events used by this controller
        this._registerEvents();
        
        PortalHelper.debugMessage('Invoices View Controller Ran');
    },
    
    // get the route variables and include them in the controller
    _registerRouteVariables: function() 
    {
        var segments = PortalMain.getRouteSegments();
        
        // set the product cd
        if (segments.length == 2) {
            this.accountId = segments[0];
            this.cycleLogId = segments[1];
        } else {
            // the uri is missing important pieces
            PortalHelper.sendToDashboard();
        }
    },
    
    // register the chart objects
    _registerCharts: function()
    {
        // create the current invoice dount chart
        var InvoiceChart = new PortalChart;
        InvoiceChart.elementId = 'products-chart';
        InvoiceChart.type = 'donut';
        InvoiceChart.dataFormat = 'dollars';
        InvoiceChart.selectEventCallback = this._invoiceChartClick;
        this.InvoiceChart = InvoiceChart;
    },
    
    // take the user to the list
    _invoiceChartClick: function(rowProperties)
    {
        // set the session saved account id to match the one selected for this account
        var accountId = PortalMain.InvoicesViewController.accountId;
        PortalMain.PortalAccounts._storeCurrentAccountId(accountId);
        
        // go to the services list of the chosen product
        var productCd = rowProperties.productCd.toLowerCase();
        var servicesUrl = PortalConfig.portalUrl + '/services/' + productCd;
        window.location.href = servicesUrl;
    },
    
    // register the javascript events
    _registerEvents:  function() 
    {   
        $('#download-invoice-button a').click(function() {
            PortalMain.InvoicesViewController._downloadInvoice();
        });
        
        $('#products-download .download-products').click(function(e) {
            e.preventDefault();
            PortalMain.InvoicesViewController._downloadProductsFile();
        });
        
        // change the account number before following the link
        $('#products-table').on('click', 'a[data-set-account="true"]', function(e) {
            var accountId = PortalMain.InvoicesViewController.accountId;
            PortalMain.PortalAccounts._storeCurrentAccountId(accountId);
        });
    },
    
    // get the invoice from the api
    _getInvoice: function()
    {
        // hide the error messages
        this._hideInvoiceError();
        
        // make the request
        var invoiceRequest = new PortalRequest;
        invoiceRequest.makeRequest(
            '/invoices/get-invoice',
            {
                accountId: this.accountId,
                cycleLogId: this.cycleLogId
            },
            function(data) {
                // fill the download invoice button
                PortalMain.InvoicesViewController._setBreadcrumbs(data);
                
                // fill the download invoice button
                PortalMain.InvoicesViewController._populateDownloadButton(data);
                
                // fill the invoice details
                PortalMain.InvoicesViewController._populateInvoiceDetails(data);
                
                // fill the invoice charges table
                PortalMain.InvoicesViewController._populateChargesTable(data);
                
                // turn off the loading, and the start-hidden
                PortalHelper.loadingOverlay('#invoice-details', false);
                PortalHelper.loadingOverlay('#charges-table', false);
            },
            function(data, code, message) {
            
                // turn off the loading, and the start-hidden
                PortalHelper.loadingOverlay('#invoice-details', false);
                
                PortalMain.ProductIndexController._showInvoiceError();
            }
        );
    },
    
    // set the breadcrumbs
    _setBreadcrumbs: function(data)
    {
        $('.breadcrumbs .bc-invoice').html('#' + data.invoice_number);    
        $('.breadcrumbs').removeClass('hidden');
    },
    
    // get the products breakdown of the invoice
    _getInvoiceProductBreakdown: function()
    {
        var invoiceProductsRequest = new PortalRequest;
        invoiceProductsRequest.makeRequest(
            '/invoices/get-invoice-products',
            {
                accountId: this.accountId,
                cycleLogId: this.cycleLogId
            },
            function(data) {
                
                // fill the product chart data
                PortalMain.InvoicesViewController._populateProductsChart(data);
                
                // fill the invoice chart data
                PortalMain.InvoicesViewController._populateProductsTable(data);
                
                // turn off the loading, and the start-hidden
                PortalHelper.loadingOverlay('#products-chart', false);
                PortalHelper.loadingOverlay('#products-table', false);
                PortalHelper.loadingOverlay('#products-download', false);
            }
        );
    },
    
    // get the invoice from the api
    _downloadInvoice: function()
    {
        var downloadInvoiceRequest = new PortalRequest;
        downloadInvoiceRequest.isBinary = true;
        downloadInvoiceRequest.makeRequest(
            '/invoices/download-invoice',
            {
                accountId: this.accountId,
                cycleLogId: this.cycleLogId
            },
            function(data) {
                // build the file name
                var fileName = 'invoice-';
                fileName += $('#account-number .value').html();
                fileName += '-';
                fileName += $('#invoice-number .value').html();
                fileName += '-';
                fileName += $('#due-date .value').html().split('.')[2];
                fileName += $('#due-date .value').html().split('.')[0];
                fileName += $('#due-date .value').html().split('.')[1];
                fileName += '.pdf';
                
                // download the file
                PortalHelper.downloadFile(data, fileName);
            }
        );
    },
    
    // populate the download invoice button
    _populateDownloadButton: function(invoice)
    { 
        // remove the button if the invoice cannot be downloaded
         if (!invoice.is_downloadable) {
             $('#download-invoice-button').remove();
             return;
         }
         
         // show the button
         $('#download-invoice-button').removeClass('hidden');
    },
    
    
    // download the orders csv from the api
    _downloadProductsFile: function()
    {
        PortalHelper.loadingOverlay('#products-download', true);
        
        var submissionData = {
            accountId: this.accountId
        };
        
        // make the request
        var downloadProductsRequest = new PortalRequest;
        downloadProductsRequest.isBinary = true;
        downloadProductsRequest.makeRequest(
            '/invoices/download-invoice-product-history',
            submissionData,
            function(data) {
                PortalHelper.loadingOverlay('#products-download', false);
                
                // build the file name
                var fileName = 'Services-';
                fileName += $('#account-number .value').html();
                fileName += '.csv';
                
                PortalHelper.downloadFile(data, fileName);
            },
            function() {
                PortalHelper.loadingOverlay('#products-download', false);
                PortalHelper.openErrorPopup(
                    'Download Error',
                    'There was an error downloading this file.'
                );
            }
        );
    },
    
    // populate the invoice details
    _populateInvoiceDetails: function(invoice)
    {   
        // set the order number
        $('#account-number .value').html(invoice.account_number);
        
        // set the invoice number
        $('#invoice-number .value').html(invoice.invoice_number);
        
        // set the total amount due
        var totalAmount = PortalHelper.numberToDollars(invoice.total_amt_due);
        $('#total-amount .value').html(totalAmount);
        
        // set the bill date
        var billDate = PortalHelper.formatDate(invoice.bill_date);
        $('#bill-date .value').html(billDate);
        
        // set the due date
        var dueDate = PortalHelper.formatDate(invoice.due_date);
        $('#due-date .value').html(dueDate);
    },
    
    // plug the invoice data into the charges table
    _populateChargesTable: function(invoice)
    {   
        // add the monthly charges
        if (invoice.monthly_charges == 0) {
            $('#charges-table .monthly-charges').remove();
        } else {
            var monthlyCharges = PortalHelper.numberToDollars(invoice.monthly_charges);
            $('#charges-table .monthly-charges .price').html(monthlyCharges);
        }
        
        // add the late charges
        if (invoice.late_payment_charges == 0) {
            $('#charges-table .late-charges').remove();
        } else {
            var lateCharges = PortalHelper.numberToDollars(invoice.late_payment_charges);
            $('#charges-table .late-charges .price').html(lateCharges);
        }
        
        // add the adjustments
        if (invoice.adjustments == 0) {
            $('#charges-table .adjustments').remove();
        } else {
            var adjustments = PortalHelper.numberToDollars(invoice.adjustments);
            $('#charges-table .adjustments .price').html(adjustments);
        }
        
        // add the taxes and fees
        if (invoice.taxes_fees_other == 0) {
            $('#charges-table .taxes-fees').remove();
        } else {
            var taxesFees = PortalHelper.numberToDollars(invoice.taxes_fees_other);
            $('#charges-table .taxes-fees .price').html(taxesFees);
        }
        
        // add the governmental surcharges
        if (invoice.governmental_charges == 0) {
            $('#charges-table .governmental-surcharges').remove();
        } else {
            var governmentalCharges = PortalHelper.numberToDollars(invoice.governmental_charges);
            $('#charges-table .governmental-surcharges .price').html(governmentalCharges);
        }
        
        // add the balance forward
        // this includes the adjustments
        if (invoice.balance_forward == 0) {
            $('#charges-table .balance-forward').remove();
        } else {
            var balanceForward = parseFloat(invoice.balance_forward);
            balanceForward += parseFloat(invoice.adjustments) * -1;
            balanceForward = PortalHelper.numberToDollars(balanceForward);
            $('#charges-table .balance-forward .price').html(balanceForward);
        }
        
        // set the total price
        var totalPrice = PortalHelper.numberToDollars(invoice.total_amt_due);
        $('#charges-total-price').html(totalPrice);
    },
    
    // plug the invoice products data into the chart
    _populateProductsChart: function(invoiceData)
    {   
        // remove the hidden class
        $('#products-chart').removeClass('box-error');
        
        // format the data for use in the chart
        var chartData = [
            ['Service', 'Price']
        ];
        for (var i in invoiceData) {
            
            // ensure the price isn't a negative number
            var productPrice = invoiceData[i].price < 0 ? 0 : invoiceData[i].price;

            var name = 'Unknown';
            if(invoiceData[i].short_product_name) {
                name = invoiceData[i].short_product_name;
            }
            chartData.push([
                name,
                productPrice
            ]);
        }
        
        // if data has a total price of 0, display an error message
        var totalPrice = 0;
        for (var i in chartData) {
            if (i > 0) { // skip the header row
                totalPrice += parseFloat(chartData[i][1]);
            }
        }
        if (totalPrice <= 0) {
            $('#products-chart').attr('data-error-message', 'There is no services breakdown for this invoice.');
            $('#products-chart').addClass('box-error');
        }
        
        // get the invoice product codes for use in the select event
        var chartProperties = [];
        for (var i in invoiceData) {
            chartProperties.push({
                productCd: invoiceData[i].product_cd
            })
        }
            
        this.InvoiceChart.data = chartData;
        this.InvoiceChart.rowProperties = chartProperties;
        this.InvoiceChart.draw();
    },
    
    // plug the invoice products data into the table
    _populateProductsTable: function(invoiceProducts)
    {   
        // clear the old components
        $('#products-table tbody tr:not(.clone-source)').remove();
        
        
        // show the components, and their mrc charges in the table
        for (var i in invoiceProducts) {
            var product = invoiceProducts[i];
            var newEntry = $('#products-table tbody .clone-source').clone();
            newEntry.removeClass('clone-source');
                
            // add the component name
            var servicesUrl = '';
            if(product.product_cd) {
                servicesUrl = PortalConfig.portalUrl + '/services/' + product.product_cd.toLowerCase();
            }
            
            var product_name = 'Unknown';
            if(product.product) {
                product_name = product.product;
            }

            $('.product a', newEntry).html(product_name);
            $('.product a', newEntry).attr('href', servicesUrl);
            
            // add the product group
            var servicesUrl = '#';
            if(product.product_group) {
                var path = product.product_group.replace(/\s+/g, '-').toLowerCase();
                servicesUrl = PortalConfig.portalUrl + '/services/' + path;
            }

            var product_group = 'Unknown';
            if(product.product_group) {
                product_group = product.product_group;
            }
            
            
            $('.group a', newEntry).html(product_group);
            $('.group a', newEntry).attr('href', servicesUrl);
            
            // add the mrc charges
            var price = PortalHelper.numberToDollars(product.price);
            $('.price', newEntry).html(price);
            
            // add to to the table
            $('#products-table tbody').append(newEntry);
        }
        
        // apply the total mrc charges
        var totalPrice = 0;
        for (var i in invoiceProducts) {
            totalPrice += invoiceProducts[i].price;
        }
        totalPrice = PortalHelper.numberToDollars(totalPrice);
        $('#products-total-price').html(totalPrice);
        
    },
    
    // hide the invoice error
    _hideInvoiceError: function(code, message)
    {
        $('#invoice-details').removeClass('box-error');
        $('#invoice-details').attr('data-error-message', '');
    },
    
    // there was an error loading the invoice data from the api, so show the error
    _showInvoiceError: function()
    {
        $('#invoice-details').addClass('box-error');
        $('#invoice-details').attr('data-error-message', 'No invoice found.');
    },
    
}